module.exports = __webpack_public_path__ + "img/937-d05fe5.png";